import {
  readStoredAttribution,
  readSuppliedAttribution,
  shouldRefreshAttribution
} from '@vio/core/src/_web/attribution'
import {removeEmpty} from '@vio/core/src/utils/object'

import type {SearchParameters} from '@findhotel/sapi'
import type {NextApiRequestCookies} from 'next/dist/server/api-utils'

export const getMetadata = (
  queryParams: URLSearchParams,
  cookies: NextApiRequestCookies,
  clickedOfferRate: number | undefined,
  vclidFromMemory: string | undefined
): SearchParameters['metadata'] => {
  // When clickedOfferRate is present, we want to ignore these parameters
  const esd = clickedOfferRate ? undefined : queryParams.get('esd')
  const epv = clickedOfferRate ? undefined : queryParams.get('epv')
  const metaPrice = clickedOfferRate
    ? undefined
    : queryParams.get('preferredRate')

  // RefreshAttribution replaces the vclid cookie after mount. A search that
  // runs before it, on the server or the client, must not send the old cookie
  // when a refresh is pending. No vclid is better than the wrong one.
  const isRefreshPending = shouldRefreshAttribution(
    readStoredAttribution(cookies),
    readSuppliedAttribution(queryParams.toString())
  )
  const vclid =
    vclidFromMemory ||
    queryParams.get('vclid') ||
    (isRefreshPending ? undefined : cookies['vclid'])

  if (!esd && !epv && !vclid && !metaPrice) {
    return null
  }

  return removeEmpty({
    esd,
    epv,
    vclid,
    metaPrice
  })
}
